import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import { CartModel } from "atoms/models";

interface CartDueTodayModel {
  registerText: string;
  registerStyle: string;
  detailText: string;
  detailStyle: string;
  header: boolean;
  total: string;
  lineItems: LineItem[];
}

interface LineItem {
  description: string;
  amount: string;
  detailStyle: string;
}

function CartInfoDueTodayModal({ show, cart, handleClose }: { show: boolean; handleClose: () => void; cart: CartModel }) {
  const TOTAL_DUE_TODAY = "Total Due Today";

  const descriptionTextStyle = (textStyle: string) => {
    if (textStyle === "bold") {
      return "fw-bold";
    } else if (textStyle === "indent") {
      return "ps-3";
    } else if (textStyle === "green") {
      return "discount-price-text fw-bold";
    } else {
      return;
    }
  };

  const amountTextStyle = (textStyle: string) => {
    if (textStyle === "bold") {
      return "fw-bold";
    } else if (textStyle === "indent") {
      return;
    } else if (textStyle === "green") {
      return "discount-price-text fw-bold";
    } else {
      return;
    }
  };

  const setLineItemHeader = (detailText: string, total: string) => {
    if (detailText !== TOTAL_DUE_TODAY) {
      return (
        <td colSpan={2}>
          <h4 className="line-item-header">{detailText}</h4>
        </td>
      );
    } else {
      return (
        <>
          <td>
            <h4 className="line-item-header-top">{detailText}</h4>
          </td>
          <td>
            <h4 className="line-item-header-top">${total}</h4>
          </td>
        </>
      );
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton style={{ borderBottom: "none" }}></Modal.Header>
      <Modal.Body>
        <Container>
          <div className="table-responsive">
            <table className="table table-borderless table-sm">
              <tbody>
                {cart?.dueToday?.categories?.length > 0
                  ? cart.dueToday.categories.map((monthly: CartDueTodayModel, index: number) => {
                      return (
                        <>
                          <tr key={index}>{setLineItemHeader(monthly.detailText, monthly.total)}</tr>
                          {monthly?.lineItems?.length > 0
                            ? monthly.lineItems.map((lineItem: LineItem, index: number) => {
                                return (
                                  <tr key={index}>
                                    <td className={descriptionTextStyle(lineItem.detailStyle)}>{lineItem.description}</td>
                                    <td className={amountTextStyle(lineItem.detailStyle)}>
                                      {lineItem.amount.includes("-") ? `${lineItem.amount.replace(/-/, "-$")}` : `$${lineItem.amount}`}
                                    </td>
                                  </tr>
                                );
                              })
                            : null}
                        </>
                      );
                    })
                  : null}
              </tbody>
            </table>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default CartInfoDueTodayModal;
